// Styles
import '@mdi/font/css/materialdesignicons.css'

// Vuetify
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { VDataTable } from 'vuetify/labs/VDataTable'
import { VDataTableServer} from 'vuetify/labs/VDataTable'
import 'vuetify/styles'

export default createVuetify({components: {...components, VDataTable, VDataTableServer},directives,  theme: {
    defaultTheme: 'hqTheme',
    themes: {
        hqTheme: {
            colors: {
            masterWhite: '#FFFFFF', //masterWhite
            whiteCardOnly: '#FEFEFE', //whiteCardOnly
            whiteInputBackground: '#FEFEFF',
            whitePopUpMenu: '#FFFEFE',
            whiteIconBackground: '#FFFEFE',
            permanentWhite: '#FFFFFE',
            whiteEditor: '#FFFFFF',
            primary500: '#000441',
            primary400: '#000443',
            primary600: '#000334',
            primary700: '#000227',
            primary800: '#00045e', //me stepper steps
            primaryTableBorder: '#000444',
            grey100: '#F4F5F8',
            grey200: '#ECEEF1',
            grey200permanent: '#ECEEF1',
            grey250: '#ECEEF1', //
            grey300: '#e3e5e8',
            grey350: '#e3e5e9', //me
            grey500: '#FFFFFF',
            grey600: '#8D9096',
            grey650: '#8D9098', //me
            grey700: '#393a3d',
            grey300permanent: '#E3E5E8',
            grey750: '#393a4d',
            green50: '#e8ffe4',
            green100: '#D4EFD0',
            green200: '#e7f6e5',
            green300: '#7ED073',
            black: '#1E1E21',
            blackBorder: '1E1E21', //me stepper steps
            permanentBlack: '#1E1E21',
            green500: '#208E11',
            blueLink: '#3398D3',
        },
    }

            }
    },
}, 
)
